<template>
  <div>
    <!-- Resultado de cada momento contable respectivamente -->
    <b-card no-body class="my-3">
      <b-tabs card>
        <b-tab v-for="res in importPoliza.result" :key="res.id" :title="res.content.poliza.momento">
          <momentos-contables-card :item="res"></momentos-contables-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MomentosContablesCard from '@/components/MomentosContables/MomentosContablesCard'

export default {
  name: 'MomentosContablesList',

  components: {
    MomentosContablesCard
  },

  computed: {
    ...mapState('momentosContablesModule', ['importPoliza'])
  }
}
</script>

<style lang="scss" scoped></style>
